<div class="container-fluid">
  <p-toast [style]="{marginTop: '80px'}"></p-toast>
  @if (formLoading) {
    <div class="progress-spinner">
      <app-spinner [formLoading]="formLoading"></app-spinner>
    </div>
  }
  <div class="d-flex justify-content-between  mt-3">
    <h2>Future Occupancy Dashboard</h2>
    <span style="float:right;top:10px;">
      <app-import-export importEnabled="false" (exportDataSelected)="exportSelected($event)"  [columns]="columns" [importDisabled]="true"></app-import-export>
    </span>
  </div>

  @if (showSearchUI) {
    <app-search-template searchLabel="Search" [showSearchButton]=true [reset]=false [showLocations]=true [showDevelopments]=true
      [showShortTermRentals]=true [showRateBuckets]=false [showBedrooms]=true [showViewTypes]=true [showSeasons]=false
      [showReservationStatuses]=false [showStartDate]=true [showEndDate]=true [showSaleDateStart]=false
      [showSaleDateEnd]=false [showListingStatus]=false [defaultStartDate]="defaultStartDate" [showSaleYear]=false
      [defaultEndDate]="defaultEndDate" [defaultShortTermRentalIds]="defaultShortTermRentalIds"
      [defaultReservationStatuses]="defaultReservationStatuses" [showCustomDateRange]="true" [dateRange]="'year'" (doSearchCB)="onSearchSubmit($event)">
    </app-search-template>
  }


  <div class="row">
    <div class="col-3">
      <span [formGroup]="form1" style="padding: 0.643rem 0.75rem !important; margin-right:10px; padding-left: 0 !important;">
        <p-multiSelect [options]="futureOccupancyColumns" formControlName="futureOccupancies" appendTo="body"
        defaultLabel="Select Future Occupancy Columns" (onChange)="selectedFutureOccupancies($event)" optionLabel="name" display="chip"></p-multiSelect>
      </span>
    </div>
  </div>

  <div class="occupany_table">
    <p-table #pt [value]="resRev" [ngStyle]="{'width': 'auto'}"
      [resizableColumns]="true" [autoLayout]="true" [responsive]="true" [scrollable]="true"
      [tableStyle]="{'min-width': '50rem'}">

      <ng-template pTemplate="header">
        <tr>
          <!-- <th rowspan="2" *ngFor="let col of columns" pFrozenColumn [pSortableColumn]="col.field" [ngStyle]="{'width': '50px'}"> -->
          @for (col of columns; track col) {
            <th pFrozenColumn [pSortableColumn]="col.field" [ngStyle]="{'width': '50px'}">
              {{col.header}}
              <p-sortIcon [field]="col.field"></p-sortIcon>
            </th>
          }
          @for (col of futureOccupancyDynamicColumn; track col) {
            <th pFrozenColumn [pSortableColumn]="col" [ngStyle]="{'width': '50px'}">
              {{col}}
              <p-sortIcon [field]="col"></p-sortIcon>
            </th>
          }
          <th>Sale Velocity</th>
          <!-- <th [attr.colspan]="6" *ngFor="let col of monthColumns"> -->
          @for (col of yearColumns; track col) {
            <th pResizableColumn>
              {{col.year | date:'y'}}
            </th>
          }
          @for (col of monthColumns; track col) {
            <th pResizableColumn>
              {{col.month | date:'MMMM y'}}
            </th>
          }
          <th [ngStyle]="{'width': 'auto'}"></th>
        </tr>
        <!-- <tr>
        <th rowspan="2" *ngFor="let col of scrollableColumns" [pSortableColumn]="col.field" [ngStyle]="{'width': '50px'}">
          {{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      </tr> -->
    </ng-template>
    <ng-template pTemplate="body" let-reservation let-rowIndex="rowIndex">
      <!-- Reservation total by Month -->
      @if (rowIndex == 0) {
        <tr>
          <td pFrozenColumn></td>
          <td pFrozenColumn></td>
          <td pFrozenColumn></td>
          <td pFrozenColumn></td>
          <td pFrozenColumn></td>
          <td style="font-weight: bold;" pFrozenColumn>Total by Month</td>
          <!-- <td></td> -->
          @if (futureOccupancyDynamicColumn.includes('revRoomRateNetTTL')) {
            <td pFrozenColumn> </td>
          }
          @if (futureOccupancyDynamicColumn.includes('revRoomRateNetAVG')) {
            <td pFrozenColumn> </td>
          }
          @if (futureOccupancyDynamicColumn.includes('ownerAndOwnerGuestNts')) {
            <td pFrozenColumn> </td>
          }
          @if (futureOccupancyDynamicColumn.includes('numNtsMaintTTL')) {
            <td pFrozenColumn> </td>
          }
          @if (futureOccupancyDynamicColumn.includes('totalOccupancy')) {
            <td pFrozenColumn> </td>
          }
          @if (futureOccupancyDynamicColumn.includes('guestOccupancy')) {
            <td pFrozenColumn> </td>
          }
          @if (futureOccupancyDynamicColumn.includes('nonGuestOccupancy')) {
            <td pFrozenColumn></td>
          }
          <td></td>
          @for (col of yearColumns; track col) {
            <td></td>
          }
          @for (reservationMonth of resRevTotalByMonth; track reservationMonth) {
            <td class="border-table-right"
              [style.background-color]="getBGColor(reservationMonth.pctNtsOcc)">
              <div title="Total nights Booked {{reservationMonth.numNightsTTL}}" style="float: left; width: 33%; font-weight: bold; margin-bottom: 0.5rem;">{{reservationMonth.numNightsTTL}}</div>
              <div title="Guest Booking {{reservationMonth.numNightsGuestTTL}}" style="float: left; width: 33%; margin-bottom: 0.5rem;">{{reservationMonth.numNightsGuestTTL}} </div>
              <div title="Owner or Maintenance Booking {{reservationMonth.numNightsTTL - reservationMonth.numNightsGuestTTL}}" style="float: left; width: 33%; margin-bottom: 0.5rem;">{{reservationMonth.numNightsTTL - reservationMonth.numNightsGuestTTL}}</div>
              <div title="Total Revanue {{reservationMonth.revRoomRateNetTTL | currency : 'USD' : 'symbol' : '1.0-0'}}" style="float: left; width: 33%; font-weight: bold; margin-bottom: 0.5rem;">{{reservationMonth.revRoomRateNetTTL | currency : 'USD' : 'symbol' : '1.0-0'}} </div>
              <div title="Average Revanue {{reservationMonth.revRoomRateNetAVG | currency : 'USD' : 'symbol' : '1.0-0'}}" style="float: right; width: 33%;">{{reservationMonth.revRoomRateNetAVG | currency : 'USD' : 'symbol' : '1.0-0'}} </div>
              <div title="Occupancy {{(reservationMonth.pctNtsOcc * 100) | number : '1.0-0'}}% (Guest, Owner, Maintenance)" style="float: right; width: 33%; font-weight: bold;">{{(reservationMonth.pctNtsOcc * 100) | number : '1.0-0'}}% </div>
            </td>
          }
          <td></td>
        </tr>
      }
      <tr>
        <td pFrozenColumn>{{reservation.locationName}}</td>
        <td pFrozenColumn>{{reservation.developmentName}}</td>
        <td pFrozenColumn>{{reservation.propertyCode}} </td>
        <td pFrozenColumn>{{reservation.rate_bucket_name}} </td>
        <td pFrozenColumn>{{reservation.numNtsTTL}} </td>
        <td pFrozenColumn>{{reservation.numNtsGuestTTL}} </td>
        @if (futureOccupancyDynamicColumn.includes('revRoomRateNetTTL')) {
          <td pFrozenColumn>{{reservation.revRoomRateNetTTL | currency : 'USD' : 'symbol' : '1.0-0'}} </td>
        }
        @if (futureOccupancyDynamicColumn.includes('revRoomRateNetAVG')) {
          <td pFrozenColumn>{{reservation.revRoomRateNetAVG | currency : 'USD' : 'symbol' : '1.0-0'}} </td>
        }
        @if (futureOccupancyDynamicColumn.includes('ownerAndOwnerGuestNts')) {
          <td pFrozenColumn>{{reservation.ownerAndOwnerGuestNts}} </td>
        }
        @if (futureOccupancyDynamicColumn.includes('numNtsMaintTTL')) {
          <td pFrozenColumn>{{reservation.numNtsMaintTTL}} </td>
        }
        @if (futureOccupancyDynamicColumn.includes('totalOccupancy')) {
          <td pFrozenColumn>{{(reservation.totalOccupancy) | number : '1.2-2'}} </td>
        }
        @if (futureOccupancyDynamicColumn.includes('guestOccupancy')) {
          <td pFrozenColumn>{{(reservation.guestOccupancy) | number : '1.2-2'}} </td>
        }
        @if (futureOccupancyDynamicColumn.includes('nonGuestOccupancy')) {
          <td pFrozenColumn>{{reservation.nonGuestOccupancy | number : '1.2-2'}} </td>
        }
        <!-- Reservation saleVelocity for Short term rental -->
        @for (saleVelocityAPI of reservation?.saleVelocityAPI; track saleVelocityAPI) {
          <td class="border-table-right" (click)="showReservationList(reservation)">
            <div title="{{saleVelocityAPI?.saleVelocity1}} ({{saleVelocityAPI?.numNightsTTL1}}) Reservation from last 0 to 5 days" style="float: left; width: 33%; font-weight: bold; margin-bottom: 0.5rem;">{{saleVelocityAPI?.saleVelocity1}} ({{saleVelocityAPI?.numNightsTTL1}})</div>
            <div title="{{saleVelocityAPI?.saleVelocity2}} ({{saleVelocityAPI?.numNightsTTL2}}) Reservation from last 5 to 15 days" style="float: left; width: 33%; font-weight: bold; margin-bottom: 0.5rem;">{{saleVelocityAPI?.saleVelocity2}} ({{saleVelocityAPI?.numNightsTTL2}})</div>
            <div title="{{saleVelocityAPI?.saleVelocity3}} ({{saleVelocityAPI?.numNightsTTL3}}) Reservation from last 15 to 30 days" style="float: left; width: 33%; font-weight: bold; margin-bottom: 0.5rem;">{{saleVelocityAPI?.saleVelocity3}} ({{saleVelocityAPI?.numNightsTTL3}})</div>
            <div title="{{saleVelocityAPI?.saleVelocity4}} ({{saleVelocityAPI?.numNightsTTL4}}) Reservation from last 30 to 60 days" style="float: left; width: 33%; font-weight: bold; margin-bottom: 0.5rem;">{{saleVelocityAPI?.saleVelocity4}} ({{saleVelocityAPI?.numNightsTTL4}})</div>
            <div title="{{saleVelocityAPI?.saleVelocity5}} ({{saleVelocityAPI?.numNightsTTL5}}) Reservation from last 60 to 90 days" style="float: left; width: 33%; font-weight: bold; margin-bottom: 0.5rem;">{{saleVelocityAPI?.saleVelocity5}} ({{saleVelocityAPI?.numNightsTTL5}})</div>
          </td>
        }
        <!-- Reservation by Year for Short term rental -->
        @for (reservationYear of reservation.reservationByYear; track reservationYear) {
          <td (click)="showReservationList(reservation)" class="border-table-right"
            [style.background-color]="getBGColor(reservationYear.pctNtsOcc)">
            <div title="Total nights Booked {{reservationYear.numNightsTTL}}" style="float: left; width: 33%; font-weight: bold; margin-bottom: 0.5rem;">{{reservationYear.numNightsTTL}}</div>
            <div title="Guest Booking {{reservationYear.numNightsGuestTTL}}" style="float: left; width: 33%; margin-bottom: 0.5rem;">{{reservationYear.numNightsGuestTTL}} </div>
            <div title="Owner or Maintenance Booking {{reservationYear.numNightsTTL - reservationYear.numNightsGuestTTL}}" style="float: left; width: 33%; margin-bottom: 0.5rem;">{{reservationYear.numNightsTTL - reservationYear.numNightsGuestTTL}}</div>
            <div title="Total Revanue {{reservationYear.revRoomRateNetTTL | currency : 'USD' : 'symbol' : '1.0-0'}}" style="float: left; width: 33%; font-weight: bold; margin-bottom: 0.5rem;">{{reservationYear.revRoomRateNetTTL | currency : 'USD' : 'symbol' : '1.0-0'}} </div>
            <div title="Average Revanue {{reservationYear.revRoomRateNetAVG | currency : 'USD' : 'symbol' : '1.0-0'}}" style="float: right; width: 33%;">{{reservationYear.revRoomRateNetAVG | currency : 'USD' : 'symbol' : '1.0-0'}} </div>
            <div title="Occupancy {{(reservationYear.pctNtsOcc * 100) | number : '1.0-0'}}% (Guest, Owner, Maintenance)" style="float: right; width: 33%; font-weight: bold;">{{(reservationYear.pctNtsOcc * 100) | number : '1.0-0'}}% </div>
          </td>
        }
        <!-- Reservation by Month for Short term rental -->
        @for (reservationMonth of reservation.reservationsByMonth; track reservationMonth) {
          <td class="border-table-right" (click)="showReservationList(reservation)"
            [style.background-color]="getBGColor(reservationMonth.pctNtsOcc)">
            <div title="Total nights Booked {{reservationMonth.numNightsTTL}}" style="float: left; width: 33%; font-weight: bold; margin-bottom: 0.5rem;">{{reservationMonth.numNightsTTL}}</div>
            <div title="Guest Booking {{reservationMonth.numNightsGuestTTL}}" style="float: left; width: 33%; margin-bottom: 0.5rem;">{{reservationMonth.numNightsGuestTTL}} </div>
            <div title="Owner or Maintenance Booking {{reservationMonth.numNightsTTL - reservationMonth.numNightsGuestTTL}}" style="float: left; width: 33%; margin-bottom: 0.5rem;">{{reservationMonth.numNightsTTL - reservationMonth.numNightsGuestTTL}}</div>
            <div title="Total Revanue {{reservationMonth.revRoomRateNetTTL | currency : 'USD' : 'symbol' : '1.0-0'}}" style="float: left; width: 33%; font-weight: bold; margin-bottom: 0.5rem;">{{reservationMonth.revRoomRateNetTTL | currency : 'USD' : 'symbol' : '1.0-0'}} </div>
            <div title="Average Revanue {{reservationMonth.revRoomRateNetAVG | currency : 'USD' : 'symbol' : '1.0-0'}}" style="float: right; width: 33%;">{{reservationMonth.revRoomRateNetAVG | currency : 'USD' : 'symbol' : '1.0-0'}} </div>
            <div title="Occupancy {{(reservationMonth.pctNtsOcc * 100) | number : '1.0-0'}}% (Guest, Owner, Maintenance)" style="float: right; width: 33%; font-weight: bold;">{{(reservationMonth.pctNtsOcc * 100) | number : '1.0-0'}}% </div>
          </td>
        }
        <td></td>
      </tr>
    </ng-template>
  </p-table>
</div>
